import AppSettings from 'src/app/common/app.settings';
import { CellActionTypes } from 'src/app/components/tables/components/cell-actions.type';
import { builTableElementTestId } from 'src/app/components/tables/table.helpers';
import { SortingOrderType, SortParams } from 'src/app/interfaces/search.interface';
import { TableCellOnActionEvent } from 'src/app/interfaces/tables.interfaces';
import { UserBasic } from 'src/app/swagger-api';
import { MaybeNull, MaybeUndefined } from 'src/app/utils';
import { SortCategories } from 'src/app/views/sort-elements/sort-drop-down/sort-drop-down.helpers';
import { sortParams } from '../../../shared/list-controller/list-controller';
import { RelationPageTabs } from '../../relation-request.enum';
import { SuggestedUser } from '../../relation-request.interface';
export type RelationRequestPageTabs =
  | RelationPageTabs.LIST
  | RelationPageTabs.REQUESTS_SENT
  | RelationPageTabs.REQUESTS_RECEIVED;

export const routeParamToTabId: (
  param: MaybeNull<string>,
  defaultTabId: RelationRequestPageTabs,
) => RelationRequestPageTabs = (param: MaybeNull<string>, defaultTabId: RelationRequestPageTabs) => {
  switch (param) {
    case 'list':
      return RelationPageTabs.LIST;
    case 'requests-sent':
      return RelationPageTabs.REQUESTS_SENT;
    case 'requests-received':
      return RelationPageTabs.REQUESTS_RECEIVED;
    default:
      console.error(`Unknown route param. Using default tab - ${defaultTabId} `);
      return defaultTabId;
  }
};

export const startedUserDialogue: (users: UserBasic[]) => MaybeUndefined<UserBasic> = (users: UserBasic[]) => {
  return users.find(
    (user: UserBasic) => user.user_id === localStorage.getItem(AppSettings.LOCALSTORE_KEY_CHAT_WITH_USERID),
  );
};

export const sortingBy: (tabId: RelationRequestPageTabs) => SortCategories = (tabId: string) =>
  tabId === RelationPageTabs.LIST ? SortCategories.NAME_ASC : SortCategories.DATE_DESC;

export type AllowedTableEvent =
  | CellActionTypes.REMOVE
  | CellActionTypes.REJECT
  | CellActionTypes.CONFIRM
  | CellActionTypes.SEND_MSG;

export type AllowedSearchTableEvent = CellActionTypes.REMOVE | CellActionTypes.ADD | CellActionTypes.SEND_MSG;
export type SearchTableAction = Record<
  AllowedSearchTableEvent,
  (event: TableCellOnActionEvent, item: SuggestedUser) => void
>;

export const buildSorting: (currentCategories: SortCategories, orderType: SortingOrderType) => SortCategories = (
  currentCategories: SortCategories,
  orderType: SortingOrderType,
) => {
  const params: SortParams = sortParams[currentCategories];

  switch (orderType) {
    case SortingOrderType.NAME:
      return params.ascending ? SortCategories.NAME_DESC : SortCategories.NAME_ASC;

    case SortingOrderType.DATE:
      return params.ascending ? SortCategories.DATE_DESC : SortCategories.DATE_ASC;

    default:
      return SortCategories.NAME_ASC;
  }
};

export function actionButtonTestId(action: CellActionTypes, event: TableCellOnActionEvent): string {
  const { cellPosition } = event;
  return builTableElementTestId(action, cellPosition.rowIndex, cellPosition.cellIndex);
}
